import { CalendarMonths } from './CalendarMonths';

export type {
  TypeCalendarMonthsProps,
  TypeDatesData,
  TypeColorData,
} from './types';
export default CalendarMonths;
